// extracted by mini-css-extract-plugin
export default {"dialog":"CreateCollection_dialog__f1y+2","title":"CreateCollection_title__aDYYD","highlight":"CreateCollection_highlight__FIOnm","input":"CreateCollection_input__LU7Rj"};